import { replacePhotosOperation } from '@/utils/product/operations';
import { updateListingScore } from '@/utils/product/score';
import { editPhotos } from '@/utils/edit/photos';

import { ATTRIBUTE } from '@/constants/attributes';

export function photos({ operation, product, ...rest }) {
  const value = operation.get('value');
  const updates = editPhotos({ product, value });

  if (updates.product.hasIn(['score', ATTRIBUTE.PHOTOS])) {
    const { shop, userFeatures } = rest;
    updates.product = updateListingScore({ product: updates.product, shop, userFeatures });
  }

  return {
    ...rest,
    product: updates.product.set('operations', replacePhotosOperation(updates)),
  };
}
